import AmwalMagentoReactButton from './AmwalMagentoReactButton';
export default AmwalMagentoReactButton;
